"use client";

/**
 * Deduplicates JS across lazily-loaded chunks (Lighthouse "Remove duplicate
 * modules in JavaScript bundles").
 *
 * Turbopack (Next 16) has no webpack splitChunks-style extraction: a module
 * shared only by *sibling* dynamic chunks (next/dynamic forms, modals,
 * sections) is copied into every one of those chunks. Modules that are
 * already available in an *ancestor* chunk group, however, are excluded from
 * all descendant chunks. See vercel/next.js#96040.
 *
 * Statically importing the heaviest shared modules here — and rendering this
 * component once from the root layout — puts them in the root chunk group,
 * so every dynamic chunk on the page references the single shared copy
 * instead of bundling its own.
 *
 * Only add modules that (a) Lighthouse reports as duplicated with meaningful
 * byte counts and (b) are loaded on effectively every page anyway.
 */
import Image from "next/image";
import Link from "next/link";
import * as countries from "@/context/countries";
import * as ipStorageUtils from "@/context/ip.storage.utils";
import * as ipUtils from "@/context/ip.utils";
import * as gaEvents from "@/helpers/gaEvents";
import * as commonModalsContext from "@/components/sections/CommonModals/context";

const hoisted = [
  Image,
  Link,
  countries,
  ipStorageUtils,
  ipUtils,
  gaEvents,
  commonModalsContext,
];

declare global {
  interface Window {
    __hoistedSharedModules?: unknown[];
  }
}

export default function HoistedSharedModules() {
  // Runtime reference so bundler tree-shaking cannot drop the imports.
  if (typeof window !== "undefined") {
    window.__hoistedSharedModules = hoisted;
  }
  return null;
}
